import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRectangleRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m9 7 1-1 6 6-6 6-1-1 5.17-5z" />
  </svg>
);
export default SvgRectangleRight;
